import { endOfDay } from "date-fns";
import { z } from "zod";

export const formSchema = z.object({
	goalValue: z.number().optional().nullable(),
	incrementValue: z.number().optional().nullable(),
	isIncrement: z.boolean().optional(),
	message: z.string().optional(),
	asOfDate: z.date().max(endOfDay(new Date())).or(z.literal("")).optional(),
	outlook: z
		.object({
			color: z.string().optional(),
			id: z.string().nullable(),
			name: z.string().optional(),
		})
		.optional()
		.nullable(),
});
